import { render } from "./afterSales.vue?vue&type=template&id=d1b161ba&scoped=true"
import script from "./afterSales.vue?vue&type=script&lang=js"
export * from "./afterSales.vue?vue&type=script&lang=js"

import "./afterSales.vue?vue&type=style&index=0&id=d1b161ba&scoped=true&lang=css"
import "./afterSales.vue?vue&type=style&index=1&id=d1b161ba&lang=css"
script.render = render
script.__scopeId = "data-v-d1b161ba"

export default script